import { render, staticRenderFns } from "./SubmitWorkModal.vue?vue&type=template&id=5527c668"
import script from "./SubmitWorkModal.vue?vue&type=script&lang=js"
export * from "./SubmitWorkModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports